import { createStyledBreakpointsTheme } from 'styled-breakpoints';
import DEFAULT_BREAKPOINTS from './breakpoints';
import { DEFAULT_BUTTON_DEFINITION } from './components/button';
import DEFAULT_PALETTES from './palettes';
import DEFAULT_SPACE_UNITS from './spacing';
import DEFAULT_TYPOGRAPHY_SCALE from './typography';
import DEFAULT_ZINDEX from './zIndex';
export const DEFAULT_REMBASE = 16;
const DEFAULT_THEME = {
  remBase: DEFAULT_REMBASE,
  zIndex: DEFAULT_ZINDEX,
  palettes: DEFAULT_PALETTES,
  typographyScale: DEFAULT_TYPOGRAPHY_SCALE,
  spaceUnits: DEFAULT_SPACE_UNITS,
  button: DEFAULT_BUTTON_DEFINITION,
  ...createStyledBreakpointsTheme({
    breakpoints: DEFAULT_BREAKPOINTS
  })
};
export default DEFAULT_THEME;

// @package output
export const theme = DEFAULT_THEME;
export * from './definition';
export * from './breakpoints';
export * from './constants';
export * from './palettes';
export * from './typography';
export * from './zIndex';
export * from './grid';
export * from './utils';
//# sourceMappingURL=index.js.map